export default __webpack_public_path__ + "assets/simg1_1simg1.e4a647cc.avif";